module.exports = __webpack_public_path__ + "images/left_top.png";